
import Sound from "../../../assets/duotone/Sound.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SoundIcon({ className, dataTestid = "SoundIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Sound data-testid={dataTestid} className={classes} {...rest} />
  );
}
